import { Modal } from '@ui/uikit/components/common/Modal';

import { MarkCheck } from '../../../icons/mono/MarkCheck';
import { Button } from '../../Button';
import { DialogButtonsWrapper, DialogLayout } from '../../Dialog';
import { Typography } from '../../Typography';
import styles from './SuccessDialog.module.scss';

interface Props {
  isOpen?: boolean;
  onClose?: () => void;
}

const SuccessDialog = ({ isOpen, onClose }: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
    >
      <DialogLayout onCancel={onClose} hideHeader hideFooter>
        <div className={styles['container']}>
          <MarkCheck className={styles['container__icon']} />
          <Typography variant="h3" textAlign="center">
            Report submitted
            <br />
            successfully
          </Typography>
          <Typography variant="caption-m" textAlign="center">
            Thank you for making
            <br />
            Magic Store better!
          </Typography>
          <DialogButtonsWrapper className={styles['container__footer']}>
            <Button width="100%" onClick={onClose}>
              Close
            </Button>
          </DialogButtonsWrapper>
        </div>
      </DialogLayout>
    </Modal>
  );
};

export { SuccessDialog };
